module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Color-b3bc83be8fc422b15130184edfa6a08b.svg";